import { render, staticRenderFns } from "./NewClientModal.vue?vue&type=template&id=504720aa"
import script from "./NewClientModal.vue?vue&type=script&lang=ts"
export * from "./NewClientModal.vue?vue&type=script&lang=ts"
import style0 from "./NewClientModal.vue?vue&type=style&index=0&id=504720aa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports